module.exports = __webpack_public_path__ + "static/media/elap.303b7fe2.png";